type DataAttributes = {
  'general-link': string;
  'first-line-text': string;
  'first-line-link-text': string;
  'first-line-link': string;
  'second-line-text': string;
  'second-line-link-text': string;
  'second-line-link': string;
  shipping: string;
};

export function extractDataAttributes(data: string): DataAttributes {
  const dataAttributes = {
    'general-link': '',
    'first-line-text': '',
    'first-line-link-text': '',
    'first-line-link': '',
    'second-line-text': '',
    'second-line-link-text': '',
    'second-line-link': '',
    shipping: '',
  };
  const regex = /data-([a-zA-Z0-9-_]+)="([^"]+)"/g;
  let match;

  while (true) {
    match = regex.exec(data);
    if (!match) break;

    const key = match[1];
    const value = match[2];
    dataAttributes[key] = value;
  }

  return dataAttributes;
}

/**
 * Checks if the data contains attributes from AEM (Adobe Experience Manager).
 * @param data - The data attributes object.
 * @returns True if AEM data is available, false otherwise.
 */
export function isDataFromAEMAvailable(data: DataAttributes) {
  return !!data['general-link'] || (!!data['first-line-text'] && !!data['second-line-text']);
}
